module.exports = __webpack_public_path__ + "static/media/wheel-center-timeline-slack.177ace54.png";